import { ImagePreview } from "./ImagePreview";
import { VideoPreview } from "./VideoPreview";
import { FilePreview } from "./FilePreview";

interface AttachmentRendererProps {
  type: "image" | "video" | "file";
  fileUrl?: string;
  fileName: string;
  isUploading: boolean;
  onRemove?: () => void;
}

export const AttachmentRenderer = ({
  type,
  fileUrl,
  fileName,
  isUploading,
  onRemove,
}: AttachmentRendererProps) => {
  if (type === "image") {
    return (
      <ImagePreview
        fileUrl={fileUrl}
        fileName={fileName}
        isUploading={isUploading}
        onRemove={onRemove}
      />
    );
  }

  if (type === "video") {
    return (
      <VideoPreview
        fileUrl={fileUrl}
        isUploading={isUploading}
        onRemove={onRemove}
      />
    );
  }

  return (
    <FilePreview
      fileName={fileName}
      isUploading={isUploading}
      onRemove={onRemove}
    />
  );
};
